import React from 'react';
import { Label } from '../../components/ui/label';

/**
 * Reusable multi-select checkbox list for the Export Center filters.
 * Replaces ~150 lines of duplicated markup across location/department/supervisor/pay-type filters.
 */
export const MultiSelectFilter = (props) => {
  const {
    icon: IconComp, label, filterKey, options, selectedValues, onToggle, onSelectAll, onDeselectAll,
    loading
  } = props;

  return (
    <div>
      <div className="flex items-center justify-between mb-1.5">
        <Label className="text-sm font-medium flex items-center gap-1.5">
          <IconComp size={14} />
          {label} ({selectedValues.length}/{options.length})
        </Label>
        {options.length > 0 && (
          <div className="flex gap-1">
            <button
              type="button"
              onClick={() => onSelectAll(filterKey, options)}
              className="text-[10px] text-[#2E5C8A] hover:underline"
            >
              All
            </button>
            <span className="text-[10px] text-muted-foreground">|</span>
            <button
              type="button"
              onClick={() => onDeselectAll(filterKey)}
              className="text-[10px] text-[#2E5C8A] hover:underline"
            >
              None
            </button>
          </div>
        )}
      </div>
      <div className="border border-input rounded-md max-h-32 overflow-y-auto p-2">
        {loading ? (
          <div className="text-sm text-muted-foreground">Loading...</div>
        ) : options.length === 0 ? (
          <div className="text-sm text-muted-foreground">No {label.toLowerCase()} available</div>
        ) : (
          options.map(opt => (
            <label key={opt} className="flex items-center gap-2 py-1 cursor-pointer hover:bg-slate-50 px-1 rounded text-sm">
              <input
                type="checkbox"
                checked={selectedValues.includes(opt)}
                onChange={() => onToggle(filterKey, opt)}
                className="rounded border-slate-300"
              />
              <span className="truncate">{opt}</span>
            </label>
          ))
        )}
      </div>
    </div>
  );
};
